<template>
  <div>
    <v-card class="ml-1 mr-1 generic-card" style="border-radius: 20px; margin: 0; margin-top: 5px">
      <div style="padding: 10px 15px; border-bottom: 1px solid #eee">
        <v-layout>
          <v-flex shrink class="text-xs-left">
            <slot name="move"></slot>
            <a
              v-if="generic.image_url"
              class="mr-2 ml-2 "
              href="javascript:void(0);"
              @click="showAddImgUrl"
            >
              <v-icon color="primary"> {{ linkurl ? 'link' : 'link_off' }} </v-icon>
            </a>
          </v-flex>
          <v-flex class="text-xs-center">
            <!-- <v-btn
              outline
              color="primary"
              small
              class="ma-0"
              v-if="
                !selectedBot.useketshop == true &&
                  !selectedBot.ketshop_api_key &&
                  !selectedBot.ketshop_api_secret &&
                  !isCatalogue
              "
              @click="onChangeMode"
            >
              <template v-if="!isProductview">{{ $t('Change to Product Format') }}</template>
              <template v-else>{{ $t('Change to Menu List Format') }}</template>

              <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
            </v-btn> -->
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <a href="javascript:void(0);" @click="onGenericChange(generic)">
              <span class="fa fa-trash"></span>
            </a>
          </v-flex>
        </v-layout>
      </div>
      <template v-if="isProductview">
        <template v-if="currentProduct">
          <template
            v-if="currentProduct.photourl && currentProduct.photourl.split(';;').length > 0"
          >
            <v-img
              :style="`height: ${ratio == 'horizontal' ? '157px' : '300px'}`"
              :src="currentProduct.photourl.split(';;')[0]"
              aspect-ratio="1"
              alt
            ></v-img>
          </template>
          <div class="pl-2 pr-2 pt-2 strong">{{ currentProduct.name | truncate(40) }}</div>
          <div class="pl-2 pr-2 pb-2">{{ currentProduct.description | truncate(90) }}</div>

          <div class="text-xs-center">
            <v-btn
              outline
              color="primary"
              v-if="isCatalogue"
              :loading="loadingProduct"
              @click="showProductLine = true"
              >{{ $t('Choose product to display') }}</v-btn
            >
            <v-btn
              v-else
              flat
              color="primary"
              :loading="loadingProduct"
              @click="showProduct = true"
              >{{ $t('Choose product to display') }}</v-btn
            >
          </div>
        </template>
        <div style="height: 200px" v-else>
          <v-layout column justify-center fill-height>
            <v-btn outline color="primary" v-if="isCatalogue" @click="showProductLine = true">{{
              $t('Choose product to display')
            }}</v-btn>
            <v-btn v-else outline color="primary" @click="showProduct = true">{{
              $t('Choose product to display')
            }}</v-btn>
          </v-layout>
        </div>

        <v-dialog v-model="showProduct">
          <v-card>
            <div class="text-xs-right">
              <v-btn fab small flat @click="closeDialog">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <generic-product
                v-model="showProduct"
                :categories="categories"
                :currentCategory.sync="currentCategory"
                :filterBadge="filterBadge"
                :pageCount="pageCount"
                :pageNumber="pageNumber"
                :filterProducts="filterProducts"
                :search.sync="search"
                :loadingProduct="loadingProduct"
                @onClickPagination="onClickPagination"
                @onSelectProduct="onSelectProduct"
                @closeDialog="closeDialog"
              ></generic-product>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-else-if="generic">
        <div class="card-img">
          <uploadfile
            v-model="generic.image_url"
            :height="ratio == 'horizontal' ? 157 : 300"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + vkey + '_image'"
            @onUploaded="onUploaded"
            v-validate="isValidate ? 'required' : ''"
          ></uploadfile>
        </div>
        <div class="text-xs-center">
          <small style="color: #969595;" v-if="isNotRatio"
            >Recommended image size: 1200 x 628 pixels</small
          >
        </div>
        <div
          :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_image') }"
          style="padding: 0 10px"
        >
          <span
            class="error--text caption"
            v-show="errors.has('generic_manage_' + vkey + '_image')"
            >{{ errors.first('generic_manage_' + vkey + '_image') }}</span
          >
        </div>
        <div class="text-xs-center">
          <v-btn
            outline
            color="primary"
            v-if="isCatalogue"
            :loading="loadingProduct"
            @click="showProductLine = true"
            >{{ $t('Choose product to display') }}</v-btn
          >
        </div>

        <div class="card-body">
          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_title') }"
            style="padding: 5px"
          >
            <textarea
              name="title"
              id="title"
              style="width: 100%; resize: none; height: 50px; font-weight: 600; border-radius: 2px 2px 2px 0px !important;"
              maxlength="80"
              :data-vv-as="$t('Title')"
              :data-vv-name="'generic_manage_' + vkey + '_title'"
              class="form-control"
              v-model="generic.title"
              :placeholder="$t('Enter Title')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span
              class="error--text caption"
              v-show="errors.has('generic_manage_' + vkey + '_title')"
              >{{ errors.first('generic_manage_' + vkey + '_title') }}</span
            >
          </div>

          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_subtitle') }"
            style="padding: 5px"
          >
            <textarea
              name="subtitle"
              id="subtitle"
              style="width: 100%; resize: none; height: 70px; border-radius: 2px 2px 2px 0px !important;"
              maxlength="80"
              :data-vv-as="$t('Subtitle')"
              :data-vv-name="'generic_manage_' + vkey + '_subtitle'"
              class="form-control"
              v-model="generic.subtitle"
              :placeholder="$t('Enter Subtitle')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span
              class="error--text caption"
              v-show="errors.has('generic_manage_' + vkey + '_subtitle')"
              >{{ errors.first('generic_manage_' + vkey + '_subtitle') }}</span
            >
          </div>
        </div>
      </template>
      <v-dialog v-model="showProductLine" persistent>
        <v-card>
          <div class="text-xs-right">
            <v-btn fab small flat @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <generic-line-product
              :productBy="productBy"
              @selectProductBy="selectProductBy"
              v-model="showProductLine"
              :categories="categories"
              :currentCategory.sync="currentCategory"
              :filterBadge="filterBadge"
              :pageCount="pageCount"
              :pageNumber.sync="pageNumber"
              :filterProducts="filterProducts"
              :search.sync="search"
              :loadingProduct="loadingProduct"
              @onClickPagination="onClickPagination"
              @onSelectProduct="onSelectProduct"
              @closeDialog="closeDialog"
              @onSave="onSave"
              :generic.sync="generic"
            ></generic-line-product>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ul v-if="generic" class="list-group list-group-flush" style="margin-bottom: 0px">
        <template v-if="generic.buttons.length > 0">
          <li
            class="list-group-item"
            style="
              border-left: none;
              border-right: none;
              border-bottom: none;
              border-top: 1px solid #eee;
              border-radius: 0px;
              text-align: center;
            "
            v-for="(button, bindex) in generic.buttons"
            :key="bindex"
          >
            <div style="padding: 10px 0; position: relative" v-if="button">
              {{ button.title }}
              <add-generic-button
                v-model="generic.buttons[bindex]"
                :key="'generic_button_' + bindex + '_' + editTimestamp"
                @onSave="editButton(bindex, $event)"
                :isEdit="true"
                right="0px"
              >
                <template slot="body">
                  &nbsp;
                  <!-- <span class="fa fa-pencil-alt"></span> -->
                </template>

                <template slot="append">
                  <v-list-tile :disabled="bindex <= 0" @click="onMoveButton(bindex, 'up', generic)">
                    <v-list-tile-title
                      :style="bindex <= 0 ? `color: lightgrey` : ''"
                      class="primary-color"
                      >{{ $t('Move up') }}</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-list-tile
                    :disabled="bindex >= generic.buttons.length - 1"
                    @click="onMoveButton(bindex, 'down', generic)"
                  >
                    <v-list-tile-title
                      :style="bindex >= generic.buttons.length - 1 ? `color: lightgrey` : ''"
                      class="primary-color"
                      >{{ $t('Move down') }}</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-list-tile @click="deleteButton(bindex)">
                    <v-list-tile-title class="primary-color">{{ $t('Delete') }}</v-list-tile-title>
                  </v-list-tile>
                </template>
              </add-generic-button>
            </div>
          </li>
        </template>
        <br v-if="selectedBot.useketshop && isCatalogue" />
        <li
          v-if="
            generic.buttons.length < (isProductview === true && productBy !== 'lineMyShop' ? 2 : 3) && !(selectedBot.useketshop && isCatalogue)
          "
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        >
          <div style="padding: 10px 0">
            <add-generic-button
              :key="'generic_new_button_' + saveTimestamp"
              v-model="newButton"
              @onSave="addNewButton"
            >
              <template slot="body">
                <i class="fa fa-plus"></i>
                {{ $t('Add button') }}
              </template>
            </add-generic-button>
          </div>
        </li>
      </ul>
    </v-card>

    <generic-link-image
      v-model="showaddLink"
      v-if="showaddLink"
      :linkurl="linkurl"
      :linktype="linktype"
      :image_url="generic.image_url"
      @onchange="onSaveLinkImgUrl"
    ></generic-link-image>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import FilterCategory from '@/components/view/template/ecommerce/FilterCategory'
import dayjs from 'dayjs'
import GenericLinkImage from './GenericLinkImage'
import GenericProduct from './GenericProduct'
import GenericLineProduct from './GenericLineProduct'

export default {
  inject: ['$validator'],
  components: {
    specialtext,
    uploadfile,
    AddGenericButton,
    FilterCategory,
    GenericLinkImage,
    GenericProduct,
    GenericLineProduct
  },
  props: {
    value: {
      default: {}
    },
    isValidate: {
      default: false,
      type: Boolean
    },
    vkey: {
      default: 0,
      type: [String, Number]
    },
    ratio: {
      default: 'square'
    },
    isCatalogue: {
      default: false,
      type: Boolean
    },
    isNotRatio: { default: false }
  },
  data: function() {
    return {
      templink: '',
      templinktype: '',
      showaddLink: false,
      linktype: 'none',
      linkurl: '',
      currentCategory: 'all',
      isProductview: false,
      generic: this.value,
      showModal: false,
      showProduct: false,
      showProductLine: false,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      currentProduct: null,
      pageNumber: 1,
      size: 10,
      productCount: 0,
      search: '',
      filterBadge: undefined,
      editTimestamp: dayjs().format('x'),
      saveTimestamp: dayjs().format('x'),
      products: [],
      loadingProduct: true,
      productBy: 'zwiz'
    }
  },
  mounted: async function() {
    const vm = this
    if (vm.generic.productid) {
      vm.isProductview = true
    } else if (vm.isCatalogue && vm.generic.buttons.length > 0 && vm.generic.title !== '') {
      vm.isProductview = false
    } else if (vm.isCatalogue && !vm.generic.image_url) {
      vm.isProductview = true
    }
    await vm.setCurrentProduct()
    var buttons = this.generic.buttons.filter(el => {
      return el != null
    })
    this.$set(this.generic, 'buttons', buttons)
    if (this.generic.default_action && this.generic.default_action.url) {
      this.linkurl = this.generic.default_action.url
      if (this.generic.image_url && this.generic.image_url == this.linkurl) {
        this.linktype = 'imglink'
      } else {
        this.linktype = 'customlink'
      }
    }
    if (!vm.currentProduct && vm.generic.productid) {
      vm.productBy = 'lineMyShop'
      await vm.setCurrentProduct()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory',
      productsStore: 'getProducts',
      loadingProductStore: 'getLoadingProduct'
    }),

    filterProducts: function() {
      let vm = this
      let products = []
      if (vm.productBy !== 'lineMyShop') {
        vm.products = vm.productsStore
        vm.loadingProduct = vm.loadingProductStore
      }
      vm.filterBadge = {
        all: vm.products.length,
        sales: 0,
        soldout: 0
      }

      $.each(vm.products, function(index, val) {
        if (parseFloat(val.price) > parseFloat(val.discountprice)) {
        }
        if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
          vm.filterBadge.sales += 1
        } else {
          var isDiscount = false
          if (val.productstock) {
            val.productstock.map(function(stock, sindex) {
              if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                isDiscount = true
              }
            })
          }

          if (isDiscount) {
            vm.filterBadge.sales += 1
          }
        }
        if (vm.currentCategory === 'sales') {
          if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
            products.push(val)
          } else {
            if (val.productstock) {
              val.productstock.map(function(stock, sindex) {
                if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                  isDiscount = true
                }
              })
            }

            if (isDiscount) {
              products.push(val)
            }
          }
        } else if (vm.currentCategory === val.categoryid) {
          products.push(val)
        }
        if (val.productstock.length === 0) {
          vm.filterBadge.soldout += 1
          if (vm.currentCategory === 'soldout') {
            products.push(val)
          }
        } else {
          $.each(val.productstock, function(sindex, stock) {
            if (stock[2] <= 0) {
              vm.filterBadge.soldout += 1
              if (vm.currentCategory === 'soldout') {
                products.push(val)
              }
              return false
            }
          })
        }
      })
      if (vm.currentCategory === 'all') {
        products = vm.products
      }

      let product = []
      if (vm.search === '') {
        product = products
      } else {
        product = products.filter(product => {
          var isFoundSkuInStock = false
          if (product.productstock && product.productstock.length > 0) {
            var stocks = product.productstock.filter(stock => {
              return (
                stock[5] &&
                stock[5] != null &&
                stock[5].toLowerCase().includes(vm.search.toLowerCase())
              )
            })
            isFoundSkuInStock = stocks.length > 0
          }
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null &&
              product.code.toLowerCase().includes(vm.search.toLowerCase())) ||
            isFoundSkuInStock
          )
        })
      }
      if (vm.productBy !== 'lineMyShop') {
        this.productCount = product.length
      }
      product = product.filter(el => {
        if (vm.selectedBot && !vm.selectedBot.zortout_is_active) {
          if (el.ref_code) {
            return !el.ref_code.includes('ZORTOUT')
          }
        }
        return el
      })
      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size

      if (vm.productBy == 'lineMyShop') {
        return product
      } else {
        return product.slice(start, end)
      }
    },
    pageCount: function() {
      const vm = this
      let l = this.productCount
      let s = this.size
      if (vm.productBy === 'lineMyShop') {
        return l
      } else {
        return Math.ceil(l / s)
      }
    }
  },
  methods: {
    async setCurrentProduct() {
      const vm = this
      await vm.getProducts()
      delete vm.generic.enable
      if (vm.selectedBot.theme == 'ecommercebasic') {
        if (vm.generic.productid) {
          vm.currentProduct = vm.products.find(function(val) {
            return val.id == vm.generic.productid
          })
        }
      }
    },
    async selectProductBy(type) {
      const vm = this
      vm.productBy = type
      await vm.getProducts()
    },
    closeDialog() {
      const vm = this
      vm.showProductLine = false
      vm.showProduct = false
    },
    getProducts: async function() {
      let vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        let data = {
          pageid: vm.selectedBot.pageid
        }
        vm.loadingProduct = true
        vm.products = []
        // if (
        //   vm.selectedBot.useketshop == true &&
        //   vm.selectedBot.ketshop_api_key &&
        //   vm.selectedBot.ketshop_api_secret
        // ) {
        //   data['limit'] = vm.size
        //   data['offset'] = vm.pageNumber * vm.size - vm.size
        //   data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
        //   data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        // }
        let apiUrl = 'getProducts'
        if (vm.productBy === 'lineMyShop') {
          apiUrl = 'getProductLineMyShop'
          data['limit'] = vm.size
          data['page'] = vm.pageNumber

          api[apiUrl](data, function(error, response) {
            if (error) {
              console.error(error)
              vm.loadingProduct = false
              resolve()
              return
            }
            if (vm.productBy === 'lineMyShop' && response.data && response.data.success) {
              response.productlist = response.data.result
              vm.productCount = response.data.totalPage
            }
            if (
              vm.selectedBot.useketshop == true &&
              vm.selectedBot.ketshop_api_key &&
              vm.selectedBot.ketshop_api_secret
            ) {
              vm.productCount = response.total_records
            }
            vm.products = response.productlist
            vm.loadingProduct = false
            resolve()
          })
        } else {
          vm.products = vm.productsStore
          vm.loadingProduct = vm.loadingProductStore
          resolve()
          return
        }
      })
    },
    onSaveLinkImgUrl(payload) {
      if (payload.linktype == 'none') {
        if (this.generic.default_action) delete this.generic.default_action
      } else {
        this.$set(this.generic, 'default_action', {
          type: 'web_url',
          url: payload.url
        })
      }

      this.linktype = payload.linktype
      this.linkurl = payload.url
    },

    showAddImgUrl() {
      this.showaddLink = true
    },
    onMoveButton: function(index, direction, item) {
      var vm = this

      if (direction == 'up') {
        item.buttons.splice(index, 0, item.buttons.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        item.buttons.splice(index, 0, item.buttons.splice(index + 1, 1)[0])
      }

      // vm.$emit('input', vm.bubbleMessages)
    },
    onUploaded(url) {
      if (this.linktype == 'imglink') {
        this.$set(this.generic, 'default_action', {
          type: 'web_url',
          url: url
        })
        this.linkurl = url
      }
      this.$emit('onSave', this.generic)
    },
    onChangeMode: function() {
      if (this.$store.getters.getPackage != 'premium') {
        return false
      }
      if (this.isProductview == true) {
        delete this.generic.productid
      } else {
        if (this.generic.buttons.length > 2) {
          var filtered = this.generic.buttons.filter(function(value, index, arr) {
            return index < 2
          })
          this.generic.buttons = filtered
        }
      }
      this.isProductview = !this.isProductview
    },
    onClickPagination: function(pageNum) {
      this.pageNumber = pageNum
      $('.v-dialog').animate({
        scrollTop: 0
      })
      if (this.productBy === 'lineMyShop') {
        this.getProducts()
      }
    },
    onSelectProduct: function(product) {
      const vm = this
      if (
        vm.selectedBot.useketshop == true &&
        vm.selectedBot.ketshop_api_key &&
        vm.selectedBot.ketshop_api_secret &&
        vm.productBy !== 'lineMyShop'
      ) {
        vm.generic.productid = product.id
        vm.isProductview = true
        vm.generic.buttons = []
      } else {
        vm.generic.image_url = product.photourl ? product.photourl.split(';;')[0] : ''
        vm.generic.subtitle = product.description
        vm.generic.title = product.name
        vm.generic.buttons[0] = {
          title: 'รายละเอียดสินค้า',
          type: 'web_url',
          url:
            vm.productBy === 'lineMyShop'
              ? `${vm.selectedBot.line_my_shop_liff_shop_url}/product/${product.id}`
              : `{shopurl}&category=all&pid=${product.id}`
        }
        vm.isProductview = false
      }
      vm.currentProduct = product
      vm.$emit('onSave', vm.generic)
      vm.showProduct = false
      vm.showProductLine = false
    },
    onSave: function() {
      const vm = this
      vm.showProductLine = false
      vm.isProductview = false
      vm.$emit('onSave', vm.generic)
    },
    onGenericChange: function(generic) {
      // generic.enable = !generic.enable
      this.$emit('onDelete')
    },
    addNewButton: function(payload) {
      const vm = this
      if (vm.generic.buttons.length < (vm.isProductview && vm.productBy !== 'lineMyShop' ? 2 : 3)) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        vm.generic.buttons.push(payload)
        vm.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
      }
      vm.saveTimestamp = dayjs().format('x')
    },
    editButton: function(index, payload) {
      if (this.generic.buttons[index]) {
        // this.generic.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.generic.buttons, index, payload)
      }
      this.editTimestamp = dayjs().format('x')
    },
    deleteButton: function(index) {
      this.generic.buttons.splice(index, 1)
    }
  },
  watch: {
    value: function() {
      this.generic = this.value
    },
    generic: function(newVal, oldVal) {
      // this.$emit('onSave')
    },
    search: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/GenericManage.vue